<fuse-card class="flex h-full flex-col">
  <div class="flex items-center gap-2 border-b px-4 py-3">
    <span class="flex-1 text-base font-semibold text-gray-900">Payment Methods</span>
    <a
      routerLink="/reports/financial/collection-report"
      [queryParams]="{ _ref: 'dashboard' }"
      class="rounded border border-transparent px-2 py-0.5 text-sm text-gray-400 transition hover:border-gray-200 hover:text-primary"
      >Full report</a
    >
  </div>
  <div class="flex-1 overflow-y-auto px-4 py-2">
    @if (dataLoader) {
      <div class="flex h-full items-center justify-center">
        <mat-spinner diameter="28" color="primary"></mat-spinner>
      </div>
    }
    @if (!dataLoader && methods.length) {
      <div class="flex flex-col gap-1">
        @for (method of methods; track method.label) {
          <div>
            <div class="mb-0.1 flex items-center justify-between text-sm">
              <span class="text-gray-500">{{ method.label }}</span>
              <span class="font-semibold text-gray-700">{{ method.percentage }}%</span>
            </div>
            <div class="h-2 w-full overflow-hidden rounded-full border border-gray-200 bg-gray-100">
              <div class="h-full rounded-full transition-all duration-700" [style.width.%]="method.percentage" [style.background]="method.color"></div>
            </div>
          </div>
        }
      </div>
    }
    @if (!dataLoader && !methods.length && !error) {
      <div class="flex h-full flex-col items-center justify-center gap-2 text-gray-400">
        <mat-icon fontIcon="payments" class="opacity-40 icon-size-8"></mat-icon>
        <span class="text-sm font-medium">No payment data</span>
      </div>
    }
  </div>
</fuse-card>
